import { Selector } from 'types';

export const getImportPageState: Selector<number> = (state) => state.ui.importFlow.pageState;

export const getImportType: Selector<string> = (state) => state.ui.importFlow.type;

export const getImportStartDate: Selector<string> = (state) => state.ui.importFlow.startDate;

export const getImportEndDate: Selector<string> = (state) => state.ui.importFlow.endDate;

export const getImportLengthOfWork: Selector<string> = (state) => state.ui.importFlow.lengthOfWork;

export const getImportPlatforms: Selector<string[]> = (state) => state.ui.importFlow.platforms;

export const getImportScanFor: Selector<string> = (state) => state.ui.importFlow.scanFor;

export const getImportUsersListFileName: Selector<string> = (state) =>
  state.ui.importFlow.usersListFileName;
